export const resolvePath = (endFile: string) => `\\infohub\\static\\${endFile}`;